import { Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";

const SelectStatusPayment = ({ value, onChange, readOnly }) => {
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const options = [
    {
      id: "paid",
      name: "Lunas",
    },
    {
      id: "pending",
      name: "Belum Bayar",
    },
  ];

  const getStatus = async () => {
    setLoading(true);
    const newData = options;
    const filteredData = newData.filter(
      (item) => !listData.find((existingItem) => existingItem.id === item.id)
    );
    setData((prevData) => [...prevData, ...filteredData]);
    setLoading(false);
  };

  useEffect(() => {
    getStatus();
  }, []);

  return (
    <Select
      style={
        readOnly ? { pointerEvents: "none", width: "100%" } : { width: "100%" }
      }
      allowClear={!readOnly}
      showSearch={!readOnly}
      value={value || null}
      optionFilterProp="label"
      placeholder="Pilih Status"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.name,
        value: e.id,
      }))}
      open={readOnly ? false : undefined}
    />
  );
};

export default SelectStatusPayment;
